import { AxiosError } from 'axios';
import { useState } from 'react';
import Swal from 'sweetalert2';
import { RecuringJobLog } from '../../../data/RecuringJobLog/schemas/RecuringJobLog.schema';
import { getRecuringJobLog } from '../../../data/RecuringJobLog/repositories/RecuringJobLog.repository';

function RecuringJobLogViewModel() {
    const [isLoading, setIsLoading] = useState(false);
    const [logs, setLogs] = useState<RecuringJobLog[]>([]);

    const fetchLogs = async (sid: string, jobType: string, status: string, startDate: string, endDate: string) => {
        setIsLoading(true);
        const element = document.getElementsByClassName('Loader__background');

        try {
            if (element.length > 0) element[0].className = 'Loader__background show';
            const data = await getRecuringJobLog({ sid, job_type: jobType, status, start_date: startDate, end_date: endDate });
            setLogs(data ?? []);
        } catch (error) {
            if (error instanceof AxiosError) {
                Swal.fire('Error', error.response?.data.message || 'ไม่ทราบสาเหตุ');
            } else if (error instanceof Error) {
                Swal.fire('Error', error.message);
            }
        } finally {
            setIsLoading(false);
            if (element.length > 0) element[0].className = 'Loader__background hide';
        }
    };

    return {
        isLoading,
        logs,
        fetchLogs
    };
}

export default RecuringJobLogViewModel;
